
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsTasteGrid extends Serenity.EntityGrid<CsTasteRow, any> {
        protected getColumnsKey() { return CsTasteColumns.columnsKey; }
        protected getDialogType() { return CsTasteDialog; }
        protected getIdProperty() { return CsTasteRow.idProperty; }
        protected getInsertPermission() { return CsTasteRow.insertPermission; }
        protected getLocalTextPrefix() { return CsTasteRow.localTextPrefix; }
        protected getService() { return CsTasteService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
    }
}